import BayunError from "./BayunError";

/**
 * Optional user-facing strings keyed by BayunError code values.
 * Apps can use this map as-is, override individual entries, or supply their own copy.
 */
const BayunErrorUserMessages = {
  [BayunError.ERROR_ACCESS_DENIED]: "Access denied.",
  [BayunError.ERROR_ENCRYPTION_FAILED]: "Encryption failed.",
  [BayunError.ERROR_DECRYPTION_FAILED]: "Decryption failed.",
  [BayunError.ERROR_ENCRYPTED_DATA_NOT_FOUND]: "Encrypted data not found.",
  [BayunError.ERROR_STORAGE_KEY_NOT_FOUND_IN_RESPONSE]:
    "Storage key not found in response.",
  [BayunError.ERROR_INVALID_PASSPHRASE]: "Incorrect passphrase",
  [BayunError.ERROR_INVALID_PASSCODE]: "Incorrect passcode",
  [BayunError.ERROR_PASSPHRASE_CANNOT_BE_NULL]: "Please enter passphrase.",
  [BayunError.ERROR_INVALID_CREDENTIALS]: "Invalid credentials",
  [BayunError.ERROR_CREDENTIALS_CANNOT_BE_NULL]: "Credentials cannot be null",
  [BayunError.ERROR_USER_INACTIVE]:
    "Please contact your admin to activate your account",
  [BayunError.ERROR_MEMBER_NOT_APPROVED_YET]:
    "Account registered, but not approved yet. Wait for your admin to approve and try logging in (do not register again)",
  [BayunError.ERROR_APP_NOT_LINKED]:
    "App not linked with Member account. Please link the app through admin panel.",
  [BayunError.ERROR_MEMBER_APP_KEY_PAIR_ALREADY_EXISTS]:
    "Member App Key Pair Already Exists",
  [BayunError.ERROR_INVALID_APP_ID]: "App doesn't exist for given App Id.",
  [BayunError.ERROR_SOMETHING_WENT_WRONG]: "Something Went Wrong",
  [BayunError.ERROR_AUTHENTICATION_FAILED]: "Authentication failed.",
  [BayunError.ERROR_INVALID_ORG_NAME]: "Org doesn't exist for given Org Name.",
  [BayunError.ERROR_GROUP_ID_CANNOT_BE_NULL]: "Group Id cannot be null",
  [BayunError.ERROR_MEMBER_DOESNT_EXIST]:
    "Member does not exists for given org member id and/or org name.",
  [BayunError.ERROR_MEMBERS_DOESNT_EXIST]:
    "Members do not exist for the given details.",
  [BayunError.ERROR_INVALID_GROUP_ID]:
    "Group does not exist for the given group id.",
  [BayunError.ERROR_MEMBER_DOESNT_BELONG_TO_GROUP]:
    "User is not a member of the specified group.",
  [BayunError.ERROR_PARTICIPANT_EXISTS_IN_GROUP]:
    "Given member id already exist in the group.",
  [BayunError.ERROR_CANNOT_JOIN_PRIVATE_GROUP]:
    "Given group is not public group. You cannot join this group.",
  [BayunError.ERROR_REAUTHENTICATION_NEEDED]:
    "Bayun session is expired. Please login again to continue.",
  [BayunError.ERROR_SESSION_NOT_READY]:
    "This sign-in is not finished yet. Please complete it and try again.",
  [BayunError.ERROR_AT_LEAST_THREE_ANSWERS_REQUIRED]:
    "Please answer at least 3 questions.",
  [BayunError.ERROR_INCORRECT_ANSWERS]: "One or more wrong answers entered.",
  [BayunError.ERROR_INVALID_APP_SECRET]: "Invalid credentials entered.",
  [BayunError.ERROR_MEMBER_VERIFICATION_FAILED]: "Member verification failed.",
  [BayunError.ERROR_GROUP_DECRYPTION_FAILED]: "Group decryption failed.",
  [BayunError.ERROR_INCOMPLETE_SECURITY_QUESTIONS]:
    "Incomplete security questions.",
  [BayunError.ERROR_USER_ALREADY_EXISTS]: "User Already Exist",
  [BayunError.ERROR_MEMBER_ALREADY_EXISTS]: "Member Already Exist",
  [BayunError.ERROR_MEMBER_ALREADY_EXISTS_FOR_A_DIFFERENT_EMAIL_ADDRESS]:
    "Member already exists for a different email address.",
  [BayunError.ERROR_USER_PASSCODE_VERIFICATION_ENABLED]:
    "User passcode verification is enabled for this account.",
  [BayunError.ERROR_GROUP_DOES_NOT_EXIST]:
    "Group does not exist, or you are not a member.",
  [BayunError.ERROR_INCORRECT_SECRET]: "Incorrect Secret.",
  [BayunError.ERROR_LINK_USER_MEMBER_ON_ADMIN]:
    "Login to Admin Panel to link this User Account with an existing Member Account to continue using the SDK APIs.",
  [BayunError.ERROR_MEMBER_APP_NOT_REGISTERED]:
    "Member Account is not registered to use the App, first Register and then try again",
  [BayunError.ERROR_NULL_PASSCODE]:
    "Agentic member login is required. Enable Login Agentic Member and enter a passcode.",
  [BayunError.ERROR_USER_IS_NOT_REGISTERED]: "User Is Not Registered",
  [BayunError.ERROR_MEMBER_AUTHORIZATION_IS_PENDING]:
    "Account Pending Authorization. Wait for the application service to authorize, and then try logging in again",
  [BayunError.ERROR_GROUP_KEY_SIGNATURE_FAILED]:
    "Group key signature could not be generated.",
  [BayunError.ERROR_GROUP_PRIVATE_KEY_SIGNATURE_FAILED]:
    "Group private key signature could not be generated.",
  [BayunError.ERROR_NO_GROUP_PARTICIPANTS_IN_THE_PARAMETERS]:
    "No group participants in the parameters.",
  [BayunError.ERROR_MEMBER_APP_NOT_APPROVED]:
    "This application is not approved. Please contact your admin to approve the application.",
  [BayunError.ERROR_REGISTRATION_FAILED_APPLICATION_IS_NOT_APPROVED]:
    "Registration failed. Application is not approved, please contact your admin for the application approval.",
  [BayunError.ERROR_INVALID_SERVER_PUBLIC_KEY]: "Invalid server public key.",
  [BayunError.ERROR_SERVER_VERIFICATION_FAILED]: "Server verification failed.",
  [BayunError.ERROR_ORG_SETTINGS_ROLLED_BACK]:
    "Org settings rolled back. Please inform the admin.",
  [BayunError.ERROR_ORG_SETTINGS_SIGNATURE_INVALID]:
    "Org settings signature is invalid.",
  [BayunError.ERROR_FACE_RECOGNITION_IS_DISABLED_FOR_THIS_DOMAIN]:
    "Face recognition is disabled for this domain. Please set enableFaceRecognition to false.",
  [BayunError.ERROR_CANNOT_SET_PARAMETER_REGISTER_FACE_ID_TO_TRUE_AS_ENABLE_FACE_RECOGNITION_IS_SET_TO_FALSE]:
    "Cannot set registerFaceId to true as enableFaceRecognition is set to false.",
  [BayunError.ERROR_NOT_A_VALID_EMAIL]: "Not a valid email.",
  [BayunError.ERROR_MEMBER_CREATION_NOT_ALLOWED]: "Member creation not allowed.",
  [BayunError.ERROR_ORG_OR_MEMBER_OR_MEMBERAPP_ALREADY_EXIST]:
    "Org or member or member app already exist",
  [BayunError.ERROR_USER_DOSE_NOT_EXISTS]: "User does not exist for given email",
  [BayunError.ERROR_DEVELOPER_KEY_VERIFICATION_FAILED]:
    "Developer key verification failed",
  [BayunError.ERROR_MEMBER_NOT_AUTHORIZED_TO_CREATE_GROUPS]:
    "Member not authorized to create groups",
  [BayunError.ERROR_TOKEN_NOT_FOUND]: "Token not found",
  [BayunError.INVALID_ORG_OR_MEMBER_NAME]: "Invalid org or member name",
  [BayunError.APP_NOT_EXIST_FOR_ORG]:
    "App is not linked to the Org. Try to Register your account with the App and wait for an Admin to approve",
  [BayunError.RE_REGISTER]: "Re-Register",
  [BayunError.USER_REGISTRATION_PENDING]: "User registration pending",
  [BayunError.APP_DOES_NOT_HAVE_THE_CORRECT_ROLE]:
    "App does not have permission to create a new Org. Check with your admin or the app-provider",
  [BayunError.INVALID_KEY_PAIR_ID]: "Invalid key pair id",
  [BayunError.AUTO_APPROVED_MEMBER_ACCESS_DENIED]:
    "Auto-approved members do not have access to this operation, ask your admin to approve you",
  [BayunError.AUTO_APPROVED_MEMBER_CANNOT_ADD_TO_GROUP]:
    "Auto-approved members cannot add members to a group.",
  [BayunError.CANNOT_ADD_MEMBER_FROM_OTHER_ORG]:
    "Members from other organizations cannot be added to the group.",
  [BayunError.ERROR_ORG_VALIDATION_POLICY_DOES_NOT_ALLOW_THIS_OPERATION]:
    "Bayun Error Your Org Validation Policy Does Not Allow This Operation",
  [BayunError.CANNOT_ADD_AUTO_APPROVED_MEMBER_TO_GROUP]:
    "Auto-approved members cannot be added to a group.",
  [BayunError.ERROR_ORGANIZATION_ALREADY_EXISTS]:
    "An organization with this name already exists.",
  [BayunError.ERROR_REGISTRATION_INCOMPLETE]:
    "User does not exist for given email",
  [BayunError.ERROR_USER_HAVE_NO_ACTIVE_MEMBERS]: "User have no active members",
  [BayunError.ERROR_USER_RECOVERY_ALREADY_IN_PROGRESS]:
    "User recovery is already in process, please contact your admin.",
  [BayunError.ERROR_USER_HAS_DEVELOPER_ACCOUNT_DURING_RECOVERY]:
    "User has a developer account and cannot continue recovery",
  [BayunError.ERROR_CANNOT_LINK_DEVELOPER_ACCOUNT_DURING_RECOVERY]:
    "Cannot link a developer account to a user in recovery",
  [BayunError.ERROR_ACCOUNT_IN_RECOVERY_MODE]: "Account is in recovery mode.",
  [BayunError.ERROR_INVALID_K_N_VALUES]:
    "Total questions (N) must be between 2 and 10, Minimum correct required (K) must be between 2 and N",
  [BayunError.ERROR_INVALID_KEY_PAIR]: "Invalid app key pair.",
  [BayunError.ERROR_MEMBER_APP_NOT_EXIST_FOR_ID]:
    "Member app doesn't exist for the given memberAppId.",
  [BayunError.ERROR_MEMBER_PUBLIC_KEY_NOT_EXISTS]:
    "Member public key does not exist.",
  [BayunError.ERROR_USER_NOT_ASSOCIATED_WITH_MEMBER]:
    "No user associated with the given memberAppId.",
  [BayunError.ERROR_MEMBER_LOCK_BOX_NOT_FOUND_FOR_MEMBER]:
    "Member lock box not found for member.",
  [BayunError.ERROR_MEMBER_CREATION_APP_KEY_PAIR_ID_REQUIRED]:
    "App is not allowed to register with, or create, a new member. Check with your admin or the app-provider",
  [BayunError.ERROR_ACCESS_APP_KEY_PAIR_ID_REQUIRED]:
    "App secret does not include an Access key pair. Login requires an Access role key pair — check with your admin or the app-provider.",
};

export default BayunErrorUserMessages;
